import { app, authentication } from '@microsoft/teams-js'
import { msalInstance, powerBiTokenRequest } from './msalConfig'

export const teamsAuthPopupPath = '/teams-auth-popup'
const teamsPowerBiAuthMarker = 'teams.powerBiAuthInProgress'

export function isTeamsAuthPopup(): boolean {
    // Entra may normalize the redirect URI back to the registered origin. Keep
    // a marker in this dialog's session so the return page still completes the
    // Teams authentication instead of rendering the portal in the dialog.
    return window.location.pathname === teamsAuthPopupPath
        || window.sessionStorage.getItem(teamsPowerBiAuthMarker) === '1'
}

export async function handleTeamsAuthPopup(): Promise<void> {
    try {
        await app.initialize()
        const response = await msalInstance.handleRedirectPromise()

        if (response) {
            window.sessionStorage.removeItem(teamsPowerBiAuthMarker)
            if (!response.accessToken) {
                throw new Error('Microsoft did not return a Power BI access token.')
            }
            authentication.notifySuccess(response.accessToken)
            return
        }

        window.sessionStorage.setItem(teamsPowerBiAuthMarker, '1')
        await msalInstance.loginRedirect({
            ...powerBiTokenRequest,
            redirectUri: `${window.location.origin}${teamsAuthPopupPath}`,
        })
    } catch (error) {
        window.sessionStorage.removeItem(teamsPowerBiAuthMarker)
        const message = error instanceof Error ? error.message : String(error)
        authentication.notifyFailure(message)
    }
}
